import React from 'react';
import PropTypes from 'prop-types';

export default function ProgramInfo({ programStatus }) {
  return (
    <li className="mb10">
      {programStatus.status === 'closed' ? (
        <>
          Program
          {' '}
          &ldquo;
          {programStatus.title}
          &rdquo;
          {' for '}
          {programStatus.member_name}
          {' '}
          was closed.
        </>
      ) : (
        <span className="text-danger">
          Unable to close the
          {' '}
          &ldquo;
          {programStatus.title}
          &rdquo;
          {' for '}
          {programStatus.member_name}
          . Ensure all sessions are completed before proceeding.
        </span>
      )}
    </li>
  );
}

ProgramInfo.propTypes = {
  programStatus: PropTypes.object.isRequired,
};
